module.exports = __webpack_public_path__ + "media/images/v4/thumb1-64f5702e84ee001b9d2177b549242f25.png";